(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-details"] && !Shopify.designMode) return;
  try {
    
  // Duas coisas, as duas por causa do HTML vir do editor da Shopify sem classe:
  //
  //   1. A tabela de medidas ganha `.tbl`, que e a regua de tabela da loja inteira.
  //      Sem isso ela sai com o desenho cru do navegador no meio de uma pagina
  //      desenhada.
  //   2. A tabela vai para dentro de um envoltorio que rola sozinho. Sem ele ela
  //      estoura a largura no celular e leva a pagina junto, que e rolagem
  //      horizontal no corpo, o defeito que a direcao proibe.
  (() => {
    const arrumar = () => {
      document.querySelectorAll('[data-written-spec] table').forEach((t) => {
        t.classList.add('tbl');
        if (t.parentElement && t.parentElement.dataset.tableWrap === '1') return;
        const caixa = document.createElement('div');
        caixa.dataset.tableWrap = '1';
        caixa.style.overflowX = 'auto';
        t.parentNode.insertBefore(caixa, t);
        caixa.appendChild(t);
      });
    };
    arrumar();
    // O editor de tema troca o HTML da secao por innerHTML, e script inserido assim
    // nao roda de novo: sem este ouvinte a tabela perde o tratamento na primeira
    // edicao e so volta com um recarregamento completo.
    document.addEventListener('shopify:section:load', arrumar);
  })();

  } catch(e) { console.error(e); }
})();
})();
